import { getSystemRoleByName } from '../../../../../backend/utils/getSystemRoleByName';
import { stopEventPropagation } from '../../../../../ui/features/badge-management/utils/stopEventPropagationHandler';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { ModalSlideoutHeader } from '@juvare/common-web-ui/ModalSlideout';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import { getAccountBadgeStatusDateText } from '../../utils/getAccountBadgeStatusDateText';
import { AccountBadgeStatusLabel } from '../AccountBadgeStatusLabel';
import { AccountBadgeSlideoutTooltip } from './AccountBadgeSlideoutTooltip';
export const AccountBadgeSlideoutHeader = ({ accountBadge, accountBadgeActions, renderCustomTopActions, }) => {
    var _a;
    const { t } = useBadgingTranslation();
    const defaultActions = [];
    if (accountBadgeActions.canEditDistributionStatus) {
        defaultActions.push(React.createElement(AccountBadgeSlideoutTooltip, { title: t('badges.badgeDetails.accountBadgeTable.menuItems.changeDistributionStatus.menuItemLabel') },
            React.createElement(IconButton, { color: 'primary', onClick: stopEventPropagation(accountBadgeActions.handleAccountBadgeDistributionStatusEdit) },
                React.createElement(PublishedWithChangesIcon, null))));
    }
    const actionElements = renderCustomTopActions ? renderCustomTopActions({ accountBadge, actions: accountBadgeActions }) : defaultActions;
    const accountSystemRoleLabel = (_a = getSystemRoleByName(accountBadge.columns.accountSystemRole)) === null || _a === void 0 ? void 0 : _a.label;
    return (React.createElement(ModalSlideoutHeader, { sx: { paddingTop: 7 } },
        React.createElement(Stack, { direction: 'row', alignItems: 'start', justifyContent: 'space-between' },
            React.createElement(Stack, { direction: 'column', spacing: 1 },
                React.createElement(Stack, { direction: 'row', spacing: 1, alignItems: 'center' },
                    React.createElement(Typography, { variant: 'h5', sx: { color: themeColors.text.bold } }, accountBadge.columns.accountDisplayName),
                    React.createElement(AccountBadgeStatusLabel, { status: accountBadge.columns.status, statusReasonTitle: accountBadge.columns.statusReasonTitle })),
                React.createElement(Stack, { gap: 1, direction: 'row', sx: {
                        alignItems: 'center',
                        minWidth: 0,
                    }, divider: React.createElement(Box, { sx: {
                            backgroundColor: themeColors.icon.disable,
                            width: '4px',
                            height: '4px',
                            borderRadius: 50,
                            flexShrink: 0,
                        } }) },
                    React.createElement(Typography, { variant: 'body2', color: themeColors.text.subtle }, accountSystemRoleLabel),
                    React.createElement(Typography, { variant: 'body2', color: themeColors.text.subtle }, getAccountBadgeStatusDateText(t, accountBadge.columns.status, accountBadge.columns.expiresAt, accountBadge.columns.statusLastUpdatedAt)))),
            actionElements)));
};
